import { render, staticRenderFns } from "./hwk-header.vue?vue&type=template&id=ef54ac18&scoped=true"
import script from "./hwk-header.vue?vue&type=script&lang=js"
export * from "./hwk-header.vue?vue&type=script&lang=js"
import style0 from "./hwk-header.vue?vue&type=style&index=0&id=ef54ac18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef54ac18",
  null
  
)

export default component.exports